import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/tendersure/prequalification/buyers',
    name: 'QedSourcingPrequalificationsBuyers',
    component: () => import('../../views/qed/prequal/Buyers.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequalifications',
    name: 'QedSourcingPrequalifications',
    component: () => import('../../views/qed/prequal/List.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/edit/prequalification/:id',
    name: 'QedSourcingPrequalification_edit_prequalification',
    component: () => import('../../views/qed/prequal/Edit.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/create/prequalification',
    name: 'QedSourcingPrequalification_create_prequalification',
    component: () => import('../../views/qed/prequal/Create.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequalification/details/:id',
    name: 'QedSourcingPrequalification_details',
    component: () => import('../../views/qed/prequal/Details.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequalification/create/category/:id',
    name: 'QedSourcingPrequalification_category_create',
    component: () => import('../../views/qed/prequal/category/Create.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequalification/edit/category/:prequal_id/:category_id',
    name: 'QedSourcingPrequalification_category_edit',
    component: () => import('../../views/qed/prequal/category/Edit.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequalification/category/details/:prequal_id/:category_id',
    name: 'QedSourcingPrequal_category_details',
    component: () => import('../../views/qed/prequal/category/Details.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/category/refresh/scores/:prequal_id/:category_id/:task_id',
    name: 'QedSourcingPrequalCategoryRefreshScores',
    component: () => import('../../views/qed/prequal/category/RefreshScoresProgress.vue')
  },
  {
    path: '/tendersure/prequal/refresh/scores/:prequal_id/:task_id',
    name: 'QedSourcingPrequalRefreshScores',
    component: () => import('../../views/qed/prequal/RefreshScoresProgress.vue')
  },
  {
    path: '/tendersure/prequalification/preview_questions/:prequal_id/:category_id',
    name: 'QedSourcingPrequalification_preview_questions',
    component: () => import('../../views/qed/prequal/category/PreviewQuestions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/create/section/:prequal_id/:category_id',
    name: 'QedSourcingPrequal_create_section',
    component: () => import('../../views/qed/prequal/category/section/Create.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/edit/section/:prequal_id/:category_id/:section_id',
    name: 'QedSourcingPrequal_edit_section',
    component: () => import('../../views/qed/prequal/category/section/Edit.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/section/questions/:category_id/:section_id',
    name: 'QedSourcingPrequal_section_questions',
    component: () => import('../../views/qed/prequal/category/section/Questions.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/create/question/:category_id/:section_id',
    name: 'QedSourcingPrequal_create_question',
    component: () => import('../../views/qed/prequal/category/section/CreateQuestion.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/edit/question/:category_id/:section_id/:id',
    name: 'QedSourcingPrequal_edit_question',
    component: () => import('../../views/qed/prequal/category/section/EditQuestion.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CRETERIA')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/qa/instructions/:category_id',
    name: 'QedSourcingPrequal_qa_instructions',
    component: () => import('../../views/qed/prequal/category/qa/AddInstructions.vue')
  },
  {
    path: '/tendersure/prequal/evaluation/instructions/:category_id',
    name: 'QedSourcingPrequal_evaluation_instructions',
    component: () => import('../../views/qed/prequal/category/evaluation/AddInstructions.vue')
  },
  {
    path: '/tendersure/prequal/conduct/qa/:category_id/:participant_id',
    name: 'QedSourcingPrequal_conduct_qa',
    component: () => import('../../views/qed/prequal/category/qa/ConductValidation.vue')
  },  
  {
    path: '/tendersure/prequal/qc_categories/:id',
    name: 'QedSourcingPrequal_qc_categories',
    component: () => import('../../views/qed/prequal/QCCategories.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed'
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/qa/quality_control_participants/:category_id',
    name: 'QedSourcingPrequal_qa_quality_control_participants',
    component: () => import('../../views/qed/prequal/category/qa/QCSuppliers.vue')
  },
  {
    path: '/tendersure/prequal/conduct/qa/:category_id/:participant_id/quality_control',
    name: 'QedSourcingPrequal_conduct_qa_quality_control',
    component: () => import('../../views/qed/prequal/category/qa/ConductValidationQC.vue')
  },
  {
    path: '/tendersure/prequal/conduct/evaluation/:category_id/:participant_id',
    name: 'QedSourcingPrequal_conduct_evalaution',
    component: () => import('../../views/qed/prequal/category/evaluation/ConductEvaluation.vue')
  },
  {
    path: '/tendersure/prequal/dd/details/:category_id',
    name: 'QedSourcingPrequal_dd_details',
    component: () => import('../../views/qed/prequal/category/dd/Participants.vue')
  },
  {
    path: '/tendersure/prequal/dd/conduct/:category_id/:participant_id/:question_id',
    name: 'QedSourcingPrequal_dd_conduct',
    component: () => import('../../views/qed/prequal/category/dd/ConductDD.vue')
  },
  {
    path: '/tendersure/prequal/dd/add/questions/:category_id',
    name: 'QedSourcingPrequal_dd_add_questions',
    component: () => import('../../views/qed/prequal/category/dd/AddDDWideQuestions.vue')
  },
  {
    path: '/tendersure/prequal/dd/add/supplier/questions/:category_id/:participant_id',
    name: 'QedSourcingPrequal_dd_add_supplier_questions',
    component: () => import('../../views/qed/prequal/category/dd/AddPerSupplierQuestion.vue')
  },
  {
    path: '/tendersure/prequal/dd/supplier/questions/:category_id/:participant_id',
    name: 'QedSourcingPrequal_dd_supplier_questions',
    component: () => import('../../views/qed/prequal/category/dd/SupplierQuestions.vue')
  },
  {
    path: '/tendersure/prequal/letters/:job_id/:category_id',
    name: 'QedSourcingPrequal_letters',
    component: () => import('../../views/qed/prequal/category/letters/ParticipantList.vue')
  },
  {
    path: '/tendersure/prequal/preview/award/letter/:job_id/:category_id/:supplier_id',
    name: 'QedSourcingPrequal_preview_award_letter',
    component: () => import('../../views/qed/prequal/category/letters/award_letter/PreviewLetter.vue')
  },
  {
    path: '/tendersure/prequal/preview/regret/letter/:job_id/:category_id/:supplier_id',
    name: 'QedSourcingPrequal_preview_regret_letter',
    component: () => import('../../views/qed/prequal/category/letters/regret_letter/PreviewLetter.vue')
  },
  {
    path: '/tendersure/prequal/category/question/upload/progress/:prequal_id/:category_id/:task_id',
    name: 'QedSourcingPrequal_category_question_upload_progress',
    component: () => import('../../views/qed/prequal/category/section/QuestionUploadProgress.vue')
  },
  {
    path: '/tendersure/prequal/question/upload/progress/:prequal_id/:task_id',
    name: 'QedPrequalQuestionUploadProgress',
    component: () => import('../../views/qed/prequal/QuestionUploadProgress.vue')
  },
  {
    path: '/tendersure/prequalification/duplicate/category/:prequal_id/:category_id',
    name: 'QedPrequalDuplicateCategory',
    component: () => import('../../views/qed/prequal/CloneCategory.vue')
  },
  {
    path: '/tendersure/prequal/reports/:id',
    name: 'QedSourcingPrequal_reports_details',
    component: () => import('../../views/qed/prequal/reports/Details.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'VIEW_REPORT')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/report/progress/:prequal_id/:task_id/:report_name',
    name: 'QedSourcingPrequal_reports_progress',
    component: () => import('../../views/qed/prequal/reports/Progress.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'VIEW_REPORT')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/report/questions-selection/:prequal_id/:report_name',
    name: 'QedSourcingPrequal_ReportSelectQuestions',
    component: () => import('../../views/qed/prequal/reports/QuestionsSelection.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'VIEW_REPORT')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/tendersure/prequal/invited/suppliers/:prequal_id/:category_id',
    name: 'QedSourcingPrequal_invited_suppliers',
    component: () => import('../../views/qed/prequal/category/InvitedSuppliers.vue')
  },
  {
    path: '/tendersure/prequal/letters/jobs',
    name: 'QedSourcingPrequalLetterJobs',
    component: () => import('../../views/qed/prequal/category/letters/LetterJobs.vue')
  },
  {
    path: '/tendersure/prequal/letters/:job_id',
    name: 'QedSourcingPrequalLetterCategories',
    component: () => import('../../views/qed/prequal/category/letters/LetterCategories.vue')
  },
  {
    path: '/tendersure/prequal/letters/success/create/:job_id',
    name: 'QedSourcingPrequalLetterSuccessCreate',
    component: () => import('../../views/qed/prequal/category/letters/award_letter/CreateAward.vue')
  },
  {
    path: '/tendersure/prequal/letters/success/edit/:job_id',
    name: 'QedSourcingPrequalLetterSuccessEdit',
    component: () => import('../../views/qed/prequal/category/letters/award_letter/EditAwardLetter.vue')
  },
  {
    path: '/tendersure/prequal/letters/custom/create/:job_id',
    name: 'QedSourcingPrequalLetterCustomCreate',
    component: () => import('../../views/qed/prequal/category/letters/custom/CreateCustom.vue')
  },
    {
    path: '/tendersure/prequal/letters/custom/edit/:job_id',
    name: 'QedSourcingPrequalLetterCustomEdit',
    component: () => import('../../views/qed/prequal/category/letters/custom/EditCustomLetter.vue')
  },
  {
    path: '/tendersure/prequal/letters/dd/create/:job_id',
    name: 'QedSourcingPrequalLetterDDCreate',
    component: () => import('../../views/qed/prequal/category/letters/dd_letter/CreateDD.vue')
  },
  {
    path: '/tendersure/prequal/letters/dd/edit/:job_id',
    name: 'QedSourcingPrequalLetterDDEdit',
    component: () => import('../../views/qed/prequal/category/letters/dd_letter/EditDDLetter.vue')
  },
  {
    path: '/tendersure/prequal/letters/regret/create/:job_id',
    name: 'QedSourcingPrequalLetterRegretCreate',
    component: () => import('../../views/qed/prequal/category/letters/regret_letter/CreateRegret.vue')
  },
  {
    path: '/tendersure/prequal/letters/regret/edit/:job_id',
    name: 'QedSourcingPrequalLetterRegretEdit',
    component: () => import('../../views/qed/prequal/category/letters/regret_letter/EditRegretLetter.vue')
  },
  {
    path: '/tendersure/prequal/zip/files/progress/:task_id/:section_id',
    name: 'QedSourcingPrequalZipFiles',
    component: () => import('../../views/qed/prequal/category/ZipFilesProgress.vue')
  },
  {
    path: '/tendersure/prequal/cat/suppliers/progress/:prequal_id/:task_id/',
    name: 'QedSourcingPrequalCatSuppliers',
    component: () => import('../../views/qed/prequal/CatSuppliersProgress.vue')
  },
  {
    path: '/tendersure/prequal/payment/reconciliation/:prequal_id',
    name: 'PRCategories',
    component: () => import('../../views/qed/prequal/PRCategories.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    },
  },
  {
    path: '/tendersure/prequal/payment/reconciliation/category/suppliers/:category_id',
    name: 'PRCategorySuppliers',
    component: () => import('../../views/qed/prequal/PRCategorySuppliers.vue')
  },
  {
    path: '/tendersure/prequal/payment/reconciliation/order/:id',
    name: 'Reconcile',
    component: () => import('../../views/qed/prequal/Reconcile.vue')
  },
  {
    path: '/tendersure/prequal/category-upload-progress/:prequal_id/:task_id/',
    name: 'TendersurePrequalCategoryUpload',
    component: () => import('../../views/qed/prequal/CategoryUploadProgress.vue')
  },
]

export default routes;
